import { BasicResourceType } from "../../../types/resources/resources.enums";
import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";
import { IProductHistory } from "../types/product-history.interface";

export function fetchHistory(resourceType: BasicResourceType, resourceId: number) {
  return http.get<SearchResults<IProductHistory>>("/change-history/", {
    params: {
      model_name: resourceType,
      model_id: resourceId,
    },
  });
}

export function nextHistory(endpoint: string) {
  return http.get<SearchResults<IProductHistory>>(endpoint);
}
